














yotpoJs = 'https://cdn-widgetsrepository.yotpo.com/v1/loader/hwP0gYqKIlg2oPxZCe6ehg'
export default

	# Assuming that nuxt-app/plugins/hydrate-customer.coffee will have run
	# before this component mounts. Since it's not async, I think it's a safe
	# bet.
	mounted: -> @loadWidgets()

	computed:

		# Do we have a customer account
		authenticated: -> !!@$store.state.customer.id

		# Tags should be rendered as JSON
		tags: -> JSON.stringify @$store.state.customer.tags

	methods:

		# Load the widget JS so it re-initializes if already loaded
		loadWidgets: ->
			if window.yotpoWidgetsContainer
			then window.yotpoWidgetsContainer.initWidgets()
			else @$loadScript yotpoJs, async: true

